import React from 'react';
import { cx } from '../../../utils/cx';
import { Button } from '../../../components/ui/Button/Button';
import { Icon } from '../../../components/ui/Icon/Icon';
import { Modal } from '../../../components/ui/Modal/Modal';
import type { SubmittedTicket } from '../../../types/support';
import styles from './SuccessModal.module.scss';

interface SuccessModalProps {
  ticket: SubmittedTicket | null;
  onClose: () => void;
  onCreateAnother: () => void;
}

export function SuccessModal({ ticket, onClose, onCreateAnother }: SuccessModalProps) {
  return (
    <Modal open={Boolean(ticket)} onClose={onClose} >
      {ticket && (
        <div className={styles.box}>
          <div className={styles.mark}>
            <Icon name="check" size={26} strokeWidth={2.2} />
          </div>
          <h3 id="successTitle">Обращение отправлено</h3>
          <p className={styles.lead}>
            Копия ушла на вашу почту. Отвечать можно прямо письмом — переписка попадёт в ту же
            заявку.
          </p>

          <div className={styles.facts}>
            <div className={cx(styles.fact, styles.wide)}>
              <span>Номер</span>
              <b>{ticket.number}</b>
            </div>

            <div className={cx(styles.fact, styles.wide)}>
              <span>Тема</span>
              <b>{ticket.topic}</b>
            </div>
          </div>

          <p className={styles.note}>
            Обращение отправлено. Статус заявки можно отслеживать в разделе "Ответы на обращения"
          </p>

          <div className={styles.actions}>
            <Button onClick={onCreateAnother}>Создать ещё одно</Button>
            <Button onClick={onClose}>
              Понятно
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
}
